import Checkbox from '@mui/material/Checkbox';
import React from 'react';
import DotIcon from '/@/components/dot-icon';

// You can add more MUI Checkbox props to personalize
const CheckboxDot = ({ theme = 'cultivio', checked, onChange, indeterminate, inputProps, name, disabled }) => {
    return (
        <Checkbox
            sx={{ display: 'flex' }}
            color='primary'
            icon={<DotIcon theme={theme} checked={checked} />}
            checkedIcon={<DotIcon theme={theme} checked={checked} />}
            indeterminateIcon={<DotIcon theme={theme} checked={checked} />}
            checked={checked}
            onChange={onChange}
            indeterminate={indeterminate}
            inputProps={inputProps}
            name={name}
            disabled={disabled}
        />
    );
};

export default CheckboxDot;
